import { Paper, styled, Tabs } from "@mui/material";

export const ScrollItemWrapper = styled(Paper)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
`;

export const ScrollContainer = styled(Tabs)`
  span {
    background: transparent;
  }
  .MuiTabs-flexContainer {
    gap: 12px;
    padding: 8px 4px;
  }
`;